import Vue from 'vue';
import VueI18n from 'vue-i18n';
import DEMessages from '@/messages/DE.json';
import ESMessages from '@/messages/ES.json';
import NLMessages from '@/messages/NL.json';
import FRMessages from '@/messages/FR.json';
import ENMessages from '@/messages/EN.json';
import ITMessages from '@/messages/IT.json';
import PTMessages from '@/messages/PT.json';
import PLMessages from '@/messages/PL.json';
import IDMessages from '@/messages/ID.json';
import CNMessages from '@/messages/ZH-HANS-CN.json';
import RUMessages from '@/messages/RU.json'

Vue.use(VueI18n);

const STORE_KEY = 'datahoreca.webapp.locale';

// wrapper around mozilla numberformats:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD',
    },
  },
  'en-CA': {
    currency: {
      style: 'currency', currency: 'CAD',
    },
  },
  nl: {
    style: 'currency', currency: 'EUR',
  },
};

const messages = {
  de: DEMessages,
  es: ESMessages,
  nl: NLMessages,
  fr: FRMessages,
  pl: PLMessages,
  en: ENMessages,
  it: ITMessages,
  pt: PTMessages,
  id: IDMessages,
  zh: CNMessages,
  'zh-CN': CNMessages,
  ru: RUMessages
};

function setLocaleToStorage(locale) {
  if (localStorage) {
    localStorage.setItem(STORE_KEY, locale);
  }
}

function getLocaleFromStorage() {
  return localStorage && localStorage.getItem(STORE_KEY);
}

VueI18n.prototype.setLocale = function setLocale(locale) {
  setLocaleToStorage(locale);
  this.locale = locale;
};

const vueI18n = new VueI18n({
  locale: getLocaleFromStorage() || navigator.language.split('-')[0],
  fallbackLocale: 'en',
  numberFormats,
  messages,
});

// If translation files become to large:
// https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
export default vueI18n;
